var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20H0V0ZM13.3333 8C12.6261 8 11.9478 8.28095 11.4477 8.78105C10.9476 9.28115 10.6667 9.95942 10.6667 10.6667C10.6667 11.3739 10.9476 12.0522 11.4477 12.5523C11.9478 13.0524 12.6261 13.3333 13.3333 13.3333H14.6667C15.0203 13.3333 15.3594 13.4738 15.6095 13.7239C15.8595 13.9739 16 14.313 16 14.6667C16 15.0203 15.8595 15.3594 15.6095 15.6095C15.3594 15.8595 15.0203 16 14.6667 16H13.3333C12.9797 16 12.6406 15.8595 12.3905 15.6095C12.1405 15.3594 12 15.0203 12 14.6667H10.6667C10.6667 15.3739 10.9476 16.0522 11.4477 16.5523C11.9478 17.0524 12.6261 17.3333 13.3333 17.3333H14.6667C15.3739 17.3333 16.0522 17.0524 16.5523 16.5523C17.0524 16.0522 17.3333 15.3739 17.3333 14.6667C17.3333 13.9594 17.0524 13.2811 16.5523 12.781C16.0522 12.281 15.3739 12 14.6667 12H13.3333C12.9797 12 12.6406 11.8595 12.3905 11.6095C12.1405 11.3594 12 11.0203 12 10.6667C12 10.313 12.1405 9.97391 12.3905 9.72386C12.6406 9.47381 12.9797 9.33333 13.3333 9.33333H14.8893C15.5027 9.33333 16 9.83067 16 10.444V10.6667H17.3333V10.444C17.3333 9.09467 16.24 8 14.8893 8H13.3333ZM4 8H10.6667V9.33333H8V17.3333H6.66667V9.33333H4V8Z",
    fill: "#00FF7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTx);
export default __webpack_public_path__ + "static/media/TX.6b7354e80ebcb12241e4b51d4ca50297.svg";
export { ForwardRef as ReactComponent };